import { render } from "./BotonesCRUD.vue?vue&type=template&id=501772ba&scoped=true"
import script from "./BotonesCRUD.vue?vue&type=script&lang=js"
export * from "./BotonesCRUD.vue?vue&type=script&lang=js"

import "./BotonesCRUD.vue?vue&type=style&index=0&id=501772ba&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-501772ba"

export default script